<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formClick" :formData="formData"></FORM>
    <table-page ref="childTable"   @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" @submitWithFiles="handleSubmitWithFiles" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>

import UPDATE from "@/components/page/update.vue";
import tablePage from "@/components/page/table.vue";
import FORM from "@/components/page/form.vue";
import URL from "@/views/newmis36/util/url";
import { dataChange } from '@/utils/dataChange';

export default {
  components: {
    FORM,
    UPDATE,
    tablePage
  },
  created () {

  },
  methods: {
    formClick (clickName, data) {
      // console.log("formClick: ", clickName, data);
      if (clickName === "init") {
        this.$refs.childTable.defaultQueryData(this.queryData);
      } else if (clickName === "query") {
        this.queryData = data;
        this.$refs.childTable.defaultGetData(this.queryData);
      } else if (clickName === "add") {
          this.modalData = {};
          this.$refs.childUpdate.open(this.modalData);
      }
    },
    bthClick (clickName, row) {
      // console.log("bthClick: ", clickName, row);
      if (clickName === "update") {
        this.modalData = {};
        this.modalData.id = row.id;
        this.modalData.platform = row.platform;
        this.modalData.image = row.iconUrl;
        this.$refs.childUpdate.open(this.modalData);
      } else if (clickName === "delete") {
        if (!row.id) this.$message.error(window.$t("txmis.socialMedia.message.invalid"));
        this.delete(row.id)
      }
    },
    submit (payload) {
      // console.log("submit: ", payload);
      this.saveOrUpdate(payload, "json");
    },
    handleSubmitWithFiles (formData) {
      // console.log("handleSubmitWithFiles: ", this.inspectFormData(formData));
      this.saveOrUpdate(formData, "formData");
    },
    saveOrUpdate (data, dataType) {
      let url = URL.socialMedia.platform.add;
      if (data.id) {
        url = URL.socialMedia.platform.update;
      }
      if (dataType === "json") {
        data = UPDATE.methods.buildFormData(data);
      }
      dataChange(url, data, (res) => {
        // console.log(res);
        if (res.code === 0) {
          if(res.result) {
            this.$message.success(window.$t("txmis.socialMedia.message.success"));
          } else {
            this.$message.error(window.$t("txmis.socialMedia.message.fail") +
            window.$t("txmis.socialMedia.message.duplicate"));
          }
          this.$refs.childUpdate.close();
          this.modalData = {};
        }
      }, (err) => {this.errorHandle(err)}, "POST", "formData").then(() => {
        this.$refs.childUpdate.close();
        this.refreshTable();
      });
    },
    delete (id) {
      // console.log("delete: ", id);
      let url = URL.socialMedia.platform.delete + "/" + id;
      dataChange(url, {}, (res) => {
        console.log(res);
        if (res.code === 0) {
          this.successHandle(res);
        }
      }, (err) => {this.errorHandle(err)}).then(() => {
        this.refreshTable();
      });
    },
    successHandle (success) {
      if(success.result) {
        this.$message.success(window.$t("txmis.socialMedia.message.success"));
      } else {
        this.$message.error(window.$t("txmis.socialMedia.message.fail"));
      }
    },
    errorHandle(error) {
      const errorMessage =
        (error.response && error.response.data && error.response.data.message) ||
        window.$t("txmis.socialMedia.message.unknown");
      this.$message.error(
        window.$t("txmis.socialMedia.message.fail") + ": " + errorMessage
      );
    },
    refreshTable() {
      this.$refs.childTable.defaultGetData(this.queryData);
      this.$forceUpdate();
    },
    // 检查FormData内容（调试用）
    inspectFormData(formData) {
      const data = {};
      for (let [key, value] of formData.entries()) {
        if (value instanceof File) {
          data[key] = `File: ${value.name} (${value.size} bytes)`;
        } else {
          data[key] = value;
        }
      }
      return data;
    },
  },
  data() {
    return {
      // Data
      queryData:{},
      modalData:{},
      // Query form
      formData: {
        hasLable : true,
        initClickName: "init",
        cols:[
          { title: window.$t("txmis.socialMedia.platform.form.name.label"), field: "platform" },
          { buttonLabel: window.$t("txmis.bt.query"), click: "query"},
          { buttonLabel: window.$t("txmis.bt.add"), click: "add"}
        ]
      },
      // Table
      pageData: {
        queryUrl: URL.socialMedia.platform.page,
        method: "post-json",
        sequence: true,
        cols: [
          { title: window.$t("txmis.socialMedia.common.id"), field: "id", hidden: true },
          { title: window.$t("txmis.socialMedia.platform.table.platform"), field: "platform" },
          { title: window.$t("txmis.socialMedia.platform.table.image"), field: "iconUrl", render:(data, full) => {
              if(!data) return "未上传";
              return '<img src="' + data + '" width=80px  alt="icon"/>';
            } },
          { title: window.$t("txmis.socialMedia.common.createdAt"), field: "createdAt" },
          { title: window.$t("txmis.socialMedia.common.updatedAt"), field: "updatedAt", render:(data, full) => {
              return data ? data : "";
            } },
          { title: window.$t("txmis.bt.operation"), btnClick: [
              { name: window.$t("txmis.bt.edit"), size: "mini", click: "update", type: "primary", icon: "el-icon-edit" },
              { name: window.$t("txmis.bt.delete"), size: "mini", click: "delete", type: "danger", icon: "el-icon-delete" }
            ]
          }
        ]
      },
      // Add/Update modal
      updateData: {
        cols: [
          { title: window.$t("txmis.socialMedia.common.id"), field: "id", hidden: true},
          { title: window.$t("txmis.socialMedia.platform.modal.platform.label"), field: "platform", type: 1, data: "", required: true, readonly: (model, col) => {
              return model.id !== undefined && model.id !== null;
            }, placeholder: window.$t("txmis.socialMedia.platform.modal.platform.placeholder") },
          { title: window.$t("txmis.socialMedia.platform.modal.image.label"), field: "image", type: 20, upload: true, drag: true, multiFile: false, autoUpload: false, preview: true },
        ]
      }
    }
  }
}

</script>

<style scoped>

</style>
